import classNames from 'classnames'
import React, { ReactNode, useId } from 'react'
import { Tooltip } from '../tooltip'
import styles from './FormSelectPlainItem.module.css'

interface Props extends Omit<React.LiHTMLAttributes<HTMLLIElement>, 'onSelect'> {
  children: ReactNode
  value?: string | number
  selected?: boolean
  disabled?: boolean
  isVisuallyFocused: boolean
  isSelected: boolean
  showItemTooltip?: boolean
  onSelect: (value?: string | number) => void
}

export const FormSelectA11yItem = ({
  children,
  selected,
  disabled,
  isVisuallyFocused,
  isSelected,
  className,
  showItemTooltip,
  value,
  onSelect,
  ...props
}: Props) => {
  const tooltipId = useId()
  const onOptionClicked = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, value?: string | number) => {
    !disabled && onSelect(value)
  }
  const onKeyDown = (event: React.KeyboardEvent<HTMLLIElement>, value?: string | number) => {
    if (event.key === 'Enter' || event.key === ' ') {
      !disabled && onSelect(value)
    }
    props.onKeyDown?.(event)
  }
  return (
    <li
      {...props}
      className={classNames(
        styles.item,
        styles.li,
        selected ? styles.selected : '',
        disabled && styles.disabled,
        'rounded-xs',
        'hover-aa-supported',
        isSelected ? 'selected-aa-supported' : isVisuallyFocused && 'bg-gray-100 border border-solid border-gray-300',
        className
      )}
      role="option"
      aria-selected={isSelected}
      onClick={(event) => onOptionClicked(event, value)}
      onKeyDown={(event) => onKeyDown(event, value)}
      tabIndex={-1}
    >
      {showItemTooltip ? (
        <Tooltip label={children} className="max-w-full" referenceId={tooltipId}>
          <p className="truncate" id={tooltipId}>
            {children}
          </p>
        </Tooltip>
      ) : (
        children
      )}
    </li>
  )
}
